import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import iconPng from "./assets/icon.png";

// Ensure the browser tab favicon uses our icon.png
const existingFavicon = document.querySelector("link[rel='icon']");
if (existingFavicon) {
  existingFavicon.setAttribute("type", "image/png");
  existingFavicon.setAttribute("href", iconPng);
} else {
  const link = document.createElement("link");
  link.setAttribute("rel", "icon");
  link.setAttribute("type", "image/png");
  link.setAttribute("href", iconPng);
  document.head.appendChild(link);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
